export default class Start {
  constructor() {
    this.startButton = document.querySelector('.main-button-start');
    this.modal = document.querySelector('.modal-intro');
    this.mainWrapper = document.querySelector('.main-container');
  }

  bindEvents() {
    this.startButton.addEventListener('click', () => this.start());
  }

  start() {
    this.modal.classList.add('hidden');
    this.mainWrapper.classList.remove('hidden');
  }
}
